import type { FormControl, FormGroup } from '@angular/forms';

export type MessageEventFilter = (event: MessageEvent) => boolean;

export enum InterframeDepositResponseType {
  SUCCESS = 'success',
  PENDING = 'pending',
  CANCELLED = 'cancel',
  FAILURE = 'failure',
  ERROR = 'error',
  ERROR_DETAILED = 'error_detailed',
  ERROR_BIN = 'binError',
  ERROR_CART = 'cartError',
  ERROR_AUTH = 'authError',
  BAD_BIN = 'badBinError',
}

export const methodSelectionRadioControl = 'RadioControl';

export enum DepositForm {
  NATIVE_CHARGE_TOGGLE = 'nativeChargeToggleFormControl',
  CONFIRMATION = 'confirmationFormGroup',
  RADIO = 'methodSelectionFormGroup',
  METHODS = 'methodsFormGroup',
}

export interface MethodSelectFormGroupType {
  [methodSelectionRadioControl]: FormControl<string | undefined>;
}

export interface ConfirmationFormGroupType {
  currencySelect: FormControl<string | undefined>;
  depositAmountInput: FormControl<number>;
}

export interface DepositFormType {
  [DepositForm.RADIO]: FormGroup<MethodSelectFormGroupType>;
  // Can't type this because it is used for register dynamic forms
  // eslint-disable-next-line local-rules/no-untyped-form
  [DepositForm.METHODS]: FormGroup;
  [DepositForm.CONFIRMATION]?: FormGroup<ConfirmationFormGroupType>;
  [DepositForm.NATIVE_CHARGE_TOGGLE]?: FormControl<boolean>;
}
